import { toDisplayValue } from 'app/modules/wallforming/components/scenes/objects/articles/utils/transformationUtils';
import { LengthUnit } from 'app/modules/wallforming/components/scenes/types/lengthUnit';

import type { DimensionUnit } from 'app/modules/wallforming/components/scenes/objects/dimensions/types/dimensionSettings';

const DECIMALS: Record<LengthUnit, number> = {
    [LengthUnit.MILLIMETER]: 0,
    [LengthUnit.CENTIMETER]: 1,
    [LengthUnit.INCHES]: 2,
    [LengthUnit.FEET]: 2
};

/**
 * Formats a length given in metres for display in the selected unit (no unit suffix).
 * Metres follow DIN 1356 (2.40, 0.125); the other units use the same conversion as the transformation tools
 * with trailing zeros trimmed (240, 22.5, 94.49).
 */
export function formatLength(valueMeters: number, unit: DimensionUnit): string {
    if (unit === 'm') {
        const millimetres = Math.round(Math.abs(valueMeters) * 1000);
        // centimetre precision; the millimetre digit is only shown when needed
        return ((Math.sign(valueMeters) * millimetres) / 1000).toFixed(millimetres % 10 === 0 ? 2 : 3);
    }
    return Number(toDisplayValue(valueMeters, unit).toFixed(DECIMALS[unit])).toString();
}

/**
 * Panel size label variants "W × H", ordered by preference; the second variant wraps onto two lines.
 * The unit is not repeated in the labels, it is defined by the dimension settings.
 */
export function formatSizeVariants(widthMeters: number, heightMeters: number, unit: DimensionUnit): string[][] {
    const w = formatLength(widthMeters, unit);
    const h = formatLength(heightMeters, unit);
    return [[`${w} × ${h}`], [`${w} ×`, h]];
}
